import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "adm",
  data() {
    return {
      step: 0,
      isLoading: false
    };
  },
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo"]),
    ...walletVuex.mapState(["isMobile"])
  },
  methods: {
    ...userVuex.mapActions(["getInapp"]),
    async onGo() {
      if (this.step > 1) {
        this.isLoading = true;
        await this.getInapp();
        this.isLoading = false;
        if (this.userInfo.in_app == 1) {
          this.$router.push("/");
        }
        return;
      }
      this.step++;
    }
  }
};